import React from "react";
import PolicyGrid from "../customer-policy-grid/CustomerPolicyGrid";
import { PolicyEndorsementsReadDto } from "../../../model/PolicyEndorsementsReadDto";
import { CustomerPolicyDetailLabels as cstPolicyEndorsementsLabel } from '../../../../shared/util/label';
import { Cell, Column } from "react-table";
import { formatWithCommas, fomratWithCommasAndDecimals } from "../../../../shared/util/currencyUtils";
import { PolicySummaryErrorMessages } from "../../../../shared/util/constant";
import {CUSTOMER_POLICY_LOBCode as cstPolicyLOBCode} from "../../../../shared/util/constant";

export interface ICustomerPolicyEndorsements {
  policyEndorsements: PolicyEndorsementsReadDto[];
  lobCode?: string;
}

const CustomerPolicyEndorsements: React.FunctionComponent<ICustomerPolicyEndorsements> = (props) => {
  const isEarthquake = Array.isArray(cstPolicyLOBCode.EARTHQUAKE) 
    ? cstPolicyLOBCode.EARTHQUAKE.includes(props.lobCode) 
    : props.lobCode === cstPolicyLOBCode.EARTHQUAKE;

  const columns: any[] = [
    {
      Header: cstPolicyEndorsementsLabel.ENDORSEMENTS,
      accessor: "coverageCode",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 400,
      cellClassName:"",
      headerClassName: ""
    },
    {
      Header: cstPolicyEndorsementsLabel.Limit_1,
      accessor: "limit1",
      Cell: row => <div><span title={row.value}>{formatWithCommas(row.value)}</span></div>,
      width: 300,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyEndorsementsLabel.Limit_2,
      accessor: "limit2",
      Cell: row => <div><span title={row.value}>{formatWithCommas(row.value)}</span></div>,
      width: 300,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: isEarthquake ? cstPolicyEndorsementsLabel.EARTHQUAKE : cstPolicyEndorsementsLabel.DED_TYPE_AMT,
      accessor: isEarthquake ? "deductible1" : "dedTypeAmt",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 380,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyEndorsementsLabel.Premium,
      accessor: "fullTermPremium",
      Cell: row => <div><span title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: 260,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
  ];

  return (
    <PolicyGrid
      data={props.policyEndorsements}
      columns={columns}
      gridId="policyEndorsementsGrid"
      disableSorting = {true}
      sortDefault={[{ id: "coverageCode", asc: true }]}
      noRecordsMessage= {PolicySummaryErrorMessages.NO_ENDORSEMENT_FOUND}
    />
  );
};

export default CustomerPolicyEndorsements;